import React, { useEffect, useState } from "react";

import { useLocation, useHistory } from "react-router-dom";
import queryString from "query-string";
import { getInvoice } from "apis/invoice";
import { Button, Col, Modal, Row } from "antd";
import { Document, Page, pdfjs } from "react-pdf";
import { DownloadOutlined } from "@ant-design/icons";
import ClickableTextButton from "components/ClickableTextButton/ClickableTextButton";
import { buildBillingManagementUri } from "utils/routes";
import Locale from "react-intl-universal";

const InvoicePDFViewer = () => {
  const { search } = useLocation();
  const values = queryString.parse(search);
  console.log("values", values);
  const [loading, setLoading] = useState(true);
  const [PDFData, setPDFData] = useState(null);
  const [blobUrl, setBlobUrl] = useState(null);

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const history = useHistory();

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  useEffect(() => {
    let pdfURL;
    pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
    if (values.invoiceNumber) {
      const invoiceNumber = values.invoiceNumber;
      const encoding = "base64";
      setLoading(true);
      getInvoice(invoiceNumber, encoding)
        .then((res) => {
          const decodedData = atob(res);
          const bytes = new Uint8Array(decodedData.length);
          for (let i = 0; i < decodedData.length; i++) {
            bytes[i] = decodedData.charCodeAt(i);
          }
          const blob = new Blob([bytes.buffer], { type: "application/pdf" });
          setPDFData(blob);

          pdfURL = URL.createObjectURL(blob);
          setBlobUrl(pdfURL);
          setLoading(false);
        })
        .catch((ex) => {
          Modal.error({
            title: ex.message,
          });
        });
    }

    return () => {
      URL.revokeObjectURL(pdfURL);
    };
  }, []);

  // const onBackButtonClick = () => history.push(buildBillingManagementUri());
  const onBackButtonClick = () => history.goBack();

  const handleDownloadInvoicePDF = () => {
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = "finport-subscription-invoice.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      <Row justify="space-between" align="middle">
        <ClickableTextButton
          text={Locale.get("Billing.back")}
          onClick={onBackButtonClick}
          showIcon={true}
          type="back"
        />
        <Col>
          <Button
            type="primary"
            style={{ height: 40 }}
            disabled={loading}
            icon={<DownloadOutlined />}
            onClick={handleDownloadInvoicePDF}
          >
            {Locale.get("Billing.downloadInvoice")}
          </Button>
        </Col>
      </Row>
      {!loading ? (
        <div
          style={{
            marginTop: 16,
          }}
        >
          <Row justify="center" align="middle">
            <div style={{ border: "1pt solid black", padding: "10pt" }}>
              <Document file={PDFData} onLoadSuccess={onDocumentLoadSuccess}>
                <Page pageNumber={pageNumber} />
              </Document>
            </div>
          </Row>
          <Row justify="center" align="middle" style={{ marginTop: 8 }}>
            <p>
              Page {pageNumber} of {numPages}
            </p>
          </Row>
        </div>
      ) : (
        <div
          style={{
            marginTop: 16,
          }}
        >
          {" "}
          <Row justify="center" align="middle">
            Loading PDF...
          </Row>
        </div>
      )}
    </div>
  );
};

export default InvoicePDFViewer;
